import { Box, styled } from '@mui/material';
import Typography from '@mui/material/Typography';
import { IdField } from '.';

export const LabelValueBox = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
}));

export const LabelText = styled(Typography)(({ theme }) => ({
    fontSize: 12,
    fontWeight: 500,
    color: theme.palette.text.secondary,
}));

export const ValueText = styled(Typography)(() => ({
    fontSize: 12,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
}));

type StyledIdFieldProps = {
    id: string;
    label: string;
};

export const StyledIdField = ({ id, label }: StyledIdFieldProps) => {
    return (
        <LabelValueBox>
            <LabelText>{`${label}:`}</LabelText>
            <ValueText>
                <IdField id={id} label={undefined} />
            </ValueText>
        </LabelValueBox>
    );
};
